var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m802.3 741.2 169.6 169.6c20.4 20.3 20.4 53.3-.2 73.9-20.4 20.4-53.9 20.1-73.9.2L728.2 815.3z",
    className: "search_svg__magnifierGlass"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M763.2 676.4c128-164.5 116.4-402.3-34.7-553.6C564.7-41 299.3-41 135.6 122.8c-163.8 163.8-163.8 429.2 0 592.9 151.2 151.2 389.1 162.7 553.5 34.7 49.9-41.2 74.1-74 74.1-74m-553.5-34.7C86.9 518.9 86.9 319.8 209.7 197c122.9-122.8 321.9-122.8 444.7 0s122.8 321.9 0 444.7-321.9 122.7-444.7 0",
    className: "search_svg__magnifierHandhold"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export default ForwardRef;